import React from 'react';
import styles from './AssetsSliderImage.module.scss';
import { AssetEntity } from 'src/modules/assets';

interface AssetsSliderImageProps {
  asset: AssetEntity;
  height: number;
}

const AssetsSliderImage: React.FunctionComponent<AssetsSliderImageProps> = ({ asset, height }) => {
  return (
    <div
      className={styles.wrapper}
      style={{ backgroundImage: `url(${asset.file?.url})`, height: `${height}px` }}
    />
  );
};

export default AssetsSliderImage;
